import { createContext, useContext, type ReactNode } from 'react';
import type { AdminDocsHost } from './types';

const AdminDocsHostContext = createContext<AdminDocsHost | null>(null);

export interface AdminDocsHostProviderProps {
  host: AdminDocsHost;
  children: ReactNode;
}

export function AdminDocsHostProvider({
  host,
  children,
}: AdminDocsHostProviderProps) {
  return (
    <AdminDocsHostContext.Provider value={host}>
      {children}
    </AdminDocsHostContext.Provider>
  );
}

export function useAdminDocsHost(): AdminDocsHost {
  const ctx = useContext(AdminDocsHostContext);
  if (!ctx) {
    throw new Error(
      'useAdminDocsHost called outside <AdminDocsHostProvider>. Wrap the lib at the SMS app root.',
    );
  }
  return ctx;
}
